import EventManager from 'dd-event-manager';
import $http from 'middleware/http';
import envs from './envs';



const FILE_NAME = 'siteconfig.xml';
const DEFAULT_ENVS = [
  {name: '本番', type: 'public' , path: 'https://dn-sundai.benesse.ne.jp/(dn|manabi)/'},
  {name: '仮'  , type: 'staging', path: 'https://dn-sundai.benesse.ne.jp/(dev|manabi_dev)/'},
  {name: '開発', type: 'develop', path: 'https?://(localhost|www\\d.test-server02.com|\\d{1,3}\\.\\d{1,3}\\.\\d{1,3}\\.\\d{1,3})'},

  // ※仮仮の定義は設定ファイル（siteconfig.xml）で持っているのでここでは定義しない
  //   @see: https://jcomintra.backlog.jp/view/BENE_IMJ_CENTER_TEST_2018-307
  // {name: '仮仮', type: 'test'   , path: 'https://dn-sundai-dev.benesse.ne.jp/(dev|manabi_dev)/'},
];
for (let env of DEFAULT_ENVS) {
  envs.add(env);
}
const preConfig = window._dnConfig || {};
const ev = {};
new EventManager(ev);



export default {
  namespaced: true,

  state: {
    originalHost: location.host,
    originalHostname: location.hostname,
    host: location.host,
    hostname: location.hostname,
    year: DN_YEAR,
    envs,
    judgementApis: [],
    ssinfo: {},
    kai: "",
    checkerOpenFlg: {},
    seisekiApi: {},
    loaded: false,
    isManabi: preConfig.isManabi === undefined ? false : preConfig.isManabi,
    selectedEnv: null,
  },

  getters: {
    year: state => state.year,
    isManabi: state => state.isManabi,
    isDn: (state, getters) => !getters['isManabi'],
    isBene: state => /\.benesse\.ne\.jp$/.test(state.hostname),
    filepath: (state, getters, rootState, rootGetters) => {
      return rootGetters['path/$join']('conf', FILE_NAME);
    },
    envList: state => {
      state.loaded;
      const envs = [];
      for (let key in state.envs.envs) {
        envs.push(state.envs.envs[key]);
      }
      return envs;
    },
    selectedEnv: state => {
      state.loaded;
      if (!state.selectedEnv) return;
      return state.envs.envs[state.selectedEnv];
    },
    currentEnv: (state, getters) => {
      return getters['selectedEnv'] || state.envs.current;
    },
    env: (state, getters) => {
      state.loaded;
      return getters['currentEnv'] && getters['currentEnv'].type || null;
    },
    envIs: (state, getters) => type => getters['env'] === type,
    judgementApiUrl: (state, getters) => {
      const env = getters['env'];
      const info = state.judgementApis.find(info => {
        return info.envs.includes(env);
      });
      const api = info || state.judgementApis[state.judgementApis.length - 1];
      return api && api.path;
    },
    judgementApiNendo: (state, getters) => {
      const env = getters['env'];
      const info = state.judgementApis.find(info => {
        return info.envs.includes(env);
      });
      const api = info || state.judgementApis[state.judgementApis.length - 1];
      return api && api.nendo;
    },
    ssinfo: (state) => {
      return state.ssinfo;
    },
    kai: (state, getters) => {
      return state.kai;
    },
    checkerOpenFlg: (state) => {
      return state.checkerOpenFlg;
    },
    seisekiApi: (state) => {
      return state.seisekiApi;
    },

    // マナビの時はリンク制御しない
    forceLinkEnabled: (state, getters) => getters['isManabi'],

    // マナビの時はステータス更新表示はしない
    dontUseStatusDisplay: (state, getters) => getters['isManabi'],
  },

  actions: {
    async load({ commit, getters }) {
      const res = await $http.get(getters['filepath']);
      commit('setData', res.data);
      ev.emit('load');
    },
    ready: () => {
      return new Promise(resolve => {
        ev.hasAndOn('load', resolve);
      });
    },
    setEnv: ({ commit }, type) => {
      commit('setEnv', type);
    },
  },

  mutations: {
    setEnv(state, type) {
      state.selectedEnv = type;
    },

    setData(state, xml) {
      const $xml = $(xml);

      // 環境設定（仮仮のみ定義されています）
      const $envs = $xml.find('environments > env');
      $envs.each(function() {
        const $env = $(this);
        const data = {
          name: $env.attr('name'),
          type: $env.attr('type'),
          path: $env.attr('path'),
        };

        // test「仮仮」環境はデフォルトとして追加する
        envs.add(data, {isDefault: data.type === 'test'});
      });

      // 判定チェッカーAPI
      const $checkerApis = $xml.find('checker api-list api');
      $checkerApis.each(function() {
        const $api = $(this);
        const data = {
          name: $api.attr('name'),
          envs: $api.attr('env').replace(/\s/g, '').split(','),
          path: $api.attr('path'),
          nendo: $api.attr('nendo'),
        };
        state.judgementApis.push(data);
      });

      // 判定チェッカー10記の得点⇔偏差値パラメータ
      const $ssinfo = $xml.find('checker ssinfo');
      $ssinfo.each(function() {
        const $ssinfo = $(this);
        const data = {
          url: $ssinfo.attr('url'),
          gakunen: $ssinfo.attr('gakunen'),
          kai: $ssinfo.attr('kai'),
          nendo: $ssinfo.attr('nendo'),
        };
        state.ssinfo = data;
      });

      // 試験回
      const $kai = $xml.find('univsearch');
      $kai.each(function() {
        const $univsearch = $(this);
        const kai = $univsearch.attr('kai');
        state.kai = kai;
      });

      // 判定チェッカー各画面開閉フラグ
      const $checkerOpenFlg = $xml.find('checker open-flg');
      $checkerOpenFlg.each(function() {
        const $flg = $(this);
        const data = {
          mock: $flg.attr('mock'),
          myuniv: $flg.attr('myuniv'),
          search: $flg.attr('search'),
          jikosaiten: $flg.attr('jikosaiten'),
          hantei: $flg.attr('hantei'),
        }
        state.checkerOpenFlg = data;
      });

      // 成績APIの各種設定
      const $seisekiApiDomain = $xml.find('seiseki-api domain');
      $seisekiApiDomain.each(function() {
        const $domain = $(this);
        const data = {
          manabi: $domain.attr('manabi'),
          dn: $domain.attr('dn'),
        }
        state.seisekiApi["domain"] = data;
      });
      const $seisekiApiExamId = $xml.find('seiseki-api exam-id');
      $seisekiApiExamId.each(function() {
        const $examId = $(this);
        const data = {
          moshi: $examId.attr('moshi'),
          dn: $examId.attr('dn'),
        }
        state.seisekiApi["examId"] = data;
      });

      state.loaded = true;
    },
  },
}


// WEBPACK FOOTER //
// ./src/js/store/modules/config/config.js